<script setup lang="ts">
import PortableEditor from '@pkg/portable-text-editor/web/PortableEditor.vue';
import type { PortableTextBlock } from '@sanity/types';

/**
 * FormFieldNotePortableText is used to display a text note on a form, from the portable text editor.
 * It's most useful in a form builder setting, when using a Dynamic Form and a form schema.
 */

const props = defineProps<{
  noteText: PortableTextBlock[];
}>();
</script>

<template>
  <div>
    <PortableEditor :content="props.noteText" class="c-form-note-portable-text" />
  </div>
</template>

<style scoped>
@import '../../../../assets/css/mixins/_mixins.index.pcss';
.c-form-note-portable-text {
  @mixin body-small;

}

</style>